import { render, staticRenderFns } from "./BauherrItem.vue?vue&type=template&id=118837a5&scoped=true&"
import script from "./BauherrItem.vue?vue&type=script&lang=js&"
export * from "./BauherrItem.vue?vue&type=script&lang=js&"
import style0 from "./BauherrItem.vue?vue&type=style&index=0&id=118837a5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118837a5",
  null
  
)

export default component.exports